/* ============================================================================
   Aug:03 — 500g upsell.  Progressive enhancement ONLY.
   Load from main-product.liquid:
     <script src="{{ 'pdp-500g-upsell.js' | asset_url }}" defer></script>

   BEHAVIOUR (revised 14-Sep)
     · trigger is the 500g tile ONLY — hover on desktop, tap/keyboard elsewhere
     · NO auto-open on 125g/250g selection
     · DYNAMIC: each open re-reads the currently selected size and swaps in that
       comparison row. Falls back to 250g if the selection has no honest
       comparison (e.g. a 500g or a spoon variant is selected).

   WHAT THIS FILE DELIBERATELY DOES NOT DO, because Liquid already did it:
     · no grade detection      — eligibility decided server-side
     · no variant matching     — the icon only exists on 500g tiles
     · no /products/x.json     — prices pre-rendered by money_with_currency
     · no formatMoney / Intl   — hence no base-currency-labelled-as-CAD bug
     · no MutationObserver     — markup ships in the initial HTML
     · no scroll/resize rig    — the tooltip is a child of the size fieldset
     · no default-variant swap — out of scope

   If this file fails to load, the page is unchanged except for a static
   BEST VALUE tag and an inert info button. Nothing breaks.
   ========================================================================== */
(function () {
  'use strict';

  var IDLE_MS = 8000;
  var LEAVE_MS = 200;

  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  /* leading run of digits — mirrors the Liquid parser, and is why this works
     on "250غ" as well as "250g | 8.8oz" */
  function gramsOf(value) {
    var m = String(value || '').match(/^\s*(\d{1,4})/);
    return m ? m[1] : null;
  }

  function init(root, tip) {
    var icons = root.querySelectorAll('[data-upsell-icon]');
    if (!icons.length) return;

    /* pre-rendered comparison rows, keyed by grams */
    var rows = {};
    Array.prototype.forEach.call(tip.querySelectorAll('[data-upsell-row]'), function (el) {
      rows[el.getAttribute('data-grams')] = el;
    });
    if (!Object.keys(rows).length) return;

    var fallback = tip.getAttribute('data-default-grams') || '250';

    var elWasLabel = tip.querySelector('[data-upsell-was-label]');
    var elWasPrice = tip.querySelector('[data-upsell-was-price]');
    var elSave = tip.querySelector('[data-upsell-save]');

    var idleTimer = null;
    var leaveTimer = null;
    var anchor = null;
    var openedByHover = false;

    /* ---- dynamic content: whatever size is selected right now ---- */
    function currentRow() {
      var checked = root.querySelector('input[type="radio"]:checked');
      var g = checked ? gramsOf(checked.value) : null;
      return rows[g] || rows[fallback] || rows[Object.keys(rows)[0]];
    }

    function fill() {
      var row = currentRow();
      if (!row) return false;
      if (elWasLabel) elWasLabel.innerHTML = row.getAttribute('data-label') || '';
      if (elWasPrice) elWasPrice.textContent = row.getAttribute('data-total') || '';
      if (elSave) elSave.textContent = row.getAttribute('data-save') || '';
      return true;
    }

    /* ---- position: pure geometry inside `root` ---- */
    function place(icon) {
      var r = root.getBoundingClientRect();
      var i = icon.getBoundingClientRect();
      if (!i.width && !i.height) return;

      var w = tip.offsetWidth;
      var centre = i.left - r.left + i.width / 2;
      var left = Math.max(4, Math.min(Math.max(4, r.width - w - 4), centre - w / 2));

      tip.style.left = left + 'px';
      tip.style.top = (i.bottom - r.top + 12) + 'px';

      var arrow = tip.querySelector('.nzhc-upsell-tip__arrow');
      if (arrow) arrow.style.left = Math.max(14, Math.min(w - 40, centre - left - 13)) + 'px';
    }

    function isOpen() { return tip.classList.contains('is-open'); }

    function open(icon, viaHover) {
      clearTimeout(leaveTimer);
      if (!fill()) return;

      anchor = icon;
      openedByHover = !!viaHover;

      tip.hidden = false;
      place(icon);
      void tip.offsetWidth;          /* commit layout so the transition runs */
      tip.classList.add('is-open');
      icon.setAttribute('aria-expanded', 'true');

      clearTimeout(idleTimer);
      idleTimer = setTimeout(close, IDLE_MS);
    }

    function close() {
      clearTimeout(idleTimer);
      clearTimeout(leaveTimer);
      if (!isOpen()) return;

      tip.classList.remove('is-open');
      if (anchor) anchor.setAttribute('aria-expanded', 'false');

      var fallbackHide = setTimeout(hide, 250);
      tip.addEventListener('transitionend', function once() {
        clearTimeout(fallbackHide);
        tip.removeEventListener('transitionend', once);
        hide();
      });

      anchor = null;
      openedByHover = false;
    }

    function hide() { if (!isOpen()) tip.hidden = true; }

    /* ---- the 500g tile is the only trigger ---- */
    Array.prototype.forEach.call(icons, function (icon) {
      icon.addEventListener('mouseenter', function () {
        if (!canHover()) return;
        clearTimeout(leaveTimer);
        clearTimeout(idleTimer);
        open(icon, true);
      });

      icon.addEventListener('mouseleave', function () {
        if (!canHover() || !openedByHover) return;
        leaveTimer = setTimeout(function () {
          if (!tip.matches(':hover')) close();
        }, LEAVE_MS);
      });

      /* the button sits inside a <label for=...>, so a bare click would also
         select the 500g variant — prevent that, the tooltip is informational */
      icon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isOpen() && anchor === icon) close();
        else open(icon, false);
      });
    });

    tip.addEventListener('mouseenter', function () {
      clearTimeout(leaveTimer);
      clearTimeout(idleTimer);
    });
    tip.addEventListener('mouseleave', function () {
      if (!canHover() || !openedByHover) return;
      leaveTimer = setTimeout(close, LEAVE_MS);
    });

    var closeBtn = tip.querySelector('[data-upsell-close]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      close();
    });

    /* keep the figures honest if the shopper changes size while it's open */
    root.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      if (isOpen()) { fill(); if (anchor) place(anchor); }
    });

    /* ---- dismissal ---- */
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (e.target.closest('[data-upsell-tip]') || e.target.closest('[data-upsell-icon]')) return;
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      var returnTo = anchor;
      close();
      if (returnTo) returnTo.focus();
    });
  }

  function boot() {
    document.querySelectorAll('[data-upsell-tip]').forEach(function (tip) {
      var root = tip.closest('.product-form__input--pill') || tip.parentElement;
      if (!root || root.__nzhcUpsell) return;
      root.__nzhcUpsell = true;
      init(root, tip);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify replaces the picker markup on some variant changes; re-bind. */
  document.addEventListener('shopify:section:load', boot);
})();
